import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=0bd2aff1&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&lang=ts"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=0bd2aff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2aff1",
  null
  
)

export default component.exports